import { CancelShiftDialogFrame } from './CancelShiftDialogFrame';

const SHIFT_DESCRIPTION =
  'Cancelling an open shift means that it will no longer be available to professionals around ' +
  'your office to accept and potentially work.';

const INTERVIEW_DESCRIPTION =
  'Cancelling an open onsite interview means that it will no longer be available to ' +
  'professionals around your office to accept and potentially get interviewed.';

export interface ICancelShiftConfirmDialogProps {
  isInterview: boolean;
  /** Disables both buttons while the cancel mutation is in flight. */
  isPending?: boolean;
  /** Go Back and Escape: dismiss without cancelling. */
  onClose: () => void;
  onConfirm: () => void;
}

/** v3 cancel confirm (GOTU-15983). Callers mount it only while open. */
export const CancelShiftConfirmDialog = ({
  isInterview,
  isPending = false,
  onClose,
  onConfirm,
}: ICancelShiftConfirmDialogProps) => (
  <CancelShiftDialogFrame
    title="Are you sure you want to cancel?"
    description={isInterview ? INTERVIEW_DESCRIPTION : SHIFT_DESCRIPTION}
    confirmLabel={isInterview ? 'Cancel Interview' : 'Cancel Shift'}
    isPending={isPending}
    onClose={onClose}
    onConfirm={onConfirm}
    data-cy="cancel-shift-confirm-dialog"
    goBackDataCy="cancel-popup-go-back"
    confirmDataCy="confirm-cancel-shift"
  />
);
